import type { FC } from 'react'

import SubnavBase, * as SubnavRecipe from '@segment/matcha/recipes/Subnav'

import type { Lesson, Course } from '@segment/api/routes/academy/types'

interface NavData extends Pick<Course, `title` | `courseNumber` | `slug`> {
  lessons: Pick<Lesson, `title` | `slug`>[]
}

interface SubnavProps {
  data: NavData[]
}

const Subnav: FC<SubnavProps> = ({ data }) => {
  return (
    <SubnavBase aria-label="Subnav mobile" label="Browse Courses" variant="vertical">
      {data.map((course, key) => (
        <SubnavRecipe.Item key={key} label={`Course ${course.courseNumber}: ${course.title}`}>
          {course.lessons.map((lesson, lessonKey) => (
            <SubnavRecipe.Item key={lessonKey} href={`/academy/${course.slug}/${lesson.slug}`} label={lesson.title} />
          ))}
        </SubnavRecipe.Item>
      ))}
    </SubnavBase>
  )
}

export default Subnav
